var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 323,
    viewBox: "0 0 328 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164,
    cy: 161.5,
    rx: 164,
    ry: 161.5,
    fill: "#529e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.628 147.5C269.628 194.593 223.141 234 164.128 234C105.115 234 58.6279 194.593 58.6279 147.5C58.6279 100.407 105.115 61 164.128 61C223.141 61 269.628 100.407 269.628 147.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3829 244.109C73.932 245.892 64.5049 248.766 59.7325 250.343C59.8901 249.837 60.0581 249.277 60.2303 248.664C60.4773 247.785 61.1846 246.668 62.5608 245.333C63.9126 244.022 65.7434 242.659 67.9481 241.26C72.3632 238.456 77.9537 235.702 83.4654 233.037C83.9173 232.819 84.3692 232.6 84.82 232.383C89.7816 229.988 94.6227 227.651 98.089 225.499C99.9558 224.34 101.656 223.098 102.759 221.775C102.917 221.585 103.072 221.383 103.219 221.168L122.731 231.514C122.73 231.583 122.726 231.655 122.72 231.731C122.664 232.417 122.366 233.601 121.007 235.033C118.159 238.034 110.61 242.145 91.3829 244.109Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4211266b9659199147dd3299d9f69966.svg";
export { ForwardRef as ReactComponent };